import { TIME_UTC_FORMAT } from 'config/constants';
import { t } from 'i18next';
import { dayjs } from 'lib/dayjs';

const z = (val: number): string | number => {
  // eslint-disable-next-line prefer-template
  return val < 10 ? '0' + val : val;
};
export const dateTimeDay = (date: string | undefined | Date | null, isISO?: boolean): string => {
  if (!date) return '';
  let datetime = new Date(date);
  if (isISO) datetime = new Date(datetime.valueOf() + datetime.getTimezoneOffset() * 60000);

  return dayjs(datetime).format(t('formats:date.lts'));
};
export const dateTimeHour = (date: string | Date): string => {
  if (!date) return '';
  const datetime = new Date(date);
  return `${z(datetime.getHours())}:${z(datetime.getMinutes())}`;
};

export const dateTime = (date: string | Date, isISO?: boolean): string => {
  return `${dateTimeDay(date, isISO)} ${dateTimeHour(date)}`;
};

export const dayMonth = (date: string): string => {
  const datetime = new Date(date);
  return `${z(datetime.getDate())}/${z(datetime.getMonth() + 1)}`;
};

export function dateTimeToISOFormat(dateTimeString: string) {
  const [date, time] = dateTimeString.split(' ');
  const [DD, MM, YYYY] = date.split('/');
  const [HH, mm] = time ? time.split(':') : ['00', '00'];
  return `${YYYY}-${MM}-${DD}T${HH}:${mm}`;
}

export const formatAxisDateTimeToEchartsPattern = (xAxisDate: string | undefined) => {
  switch (xAxisDate) {
    case 'MM/DD/YYYY':
      return '{MM}/{dd}';
    case 'MM/DD/YYYY HH:mm':
      return '{MM}/{dd} {HH}:{mm}';
    case 'DD/MM/YYYY HH:mm':
      return '{dd}/{MM} {HH}:{mm}';
    case 'DD/MM/YY':
    case 'DD/MM/YYYY':
      return '{dd}/{MM}';
    case 'HH:mm:ss':
      return '{HH}:{mm}:{ss}';
    default:
      return '{HH}:{mm}';
  }
};
export const getDuration = (start: string, end?: string | null) => {
  const durationEnd = !end || end === 'NaT' ? new Date() : end;
  return dayjs.duration(dayjs(durationEnd).diff(dayjs(start), 'minute'), 'minutes');
};
export const formatDurationString = (start: string, end?: string | null): string => {
  const duration = getDuration(start, end);

  const months = duration.months();

  if (months > 0) {
    const days = duration.days() + months * 30;

    return `${days}d ${duration.format('H[h] mm[m]')}`;
  }

  return duration.format('D[d] H[h] mm[m]');
};
export const sortDatesDesc = (a: string, b: string, format?: string) => {
  const dayjsA = dayjs(a, format);
  const dayjsB = dayjs(b, format);
  if (dayjsA.isBefore(dayjsB)) {
    return -1;
  }
  if (dayjsB.isBefore(dayjsA)) {
    return 1;
  }
  return 0;
};

export const sortDates = (a: string, b: string, format?: string) => {
  const dayjsA = dayjs(a, format);
  const dayjsB = dayjs(b, format);
  if (dayjsA.isBefore(dayjsB)) {
    return 1;
  }
  if (dayjsB.isBefore(dayjsA)) {
    return -1;
  }
  return 0;
};

export const utcDatetime = (
  date?: string | Date | null,
  dateFormat = TIME_UTC_FORMAT,
): string | null => {
  if (!date) return null;
  try {
    return dayjs(date).utc().format(dateFormat);
  } catch (e) {
    console.error('Error parsing date', e);
    return null;
  }
};
